module.exports = __webpack_public_path__ + "static/media/toggle-off.5e4fe687.svg";